import React from "react"
import "./Icon.css"

export default props => {
  return (
    <svg
      className="Icon Icon-Stag"
      x="0px"
      y="0px"
      viewBox="0 0 100 80"
      style={{enableBackground: "new 0 0 100 80"}}
      xmlSpace="preserve"
      {...props}
    >
      <title>
        {props.title || "Antlers"}
      </title>
      <path
        fill={props.fill}
        d="M63.3,54.6c2.4-3.4,1.4-8.4,1.4-10.1c0.1-1.7,0.2,0.3,1-3.8c0.4-1.9,0.8-2.6,1.1-2.6c0.4,0,0.7,1,0.7,2.4  c0,2.6,0.1,8.9,2.9,9.8c0.1,0,0.1,0,0.2,0c3.8,0,8.4-2.6,12-5.4c4.3-5.3-3.9-6.8-8.5-9c-2.7-1.2-4.9-3.3-6.2-5.9  c-2.3-4.7-2.8-6.3-2.3-6.3c0.6,0,2.7,2.7,4.2,4.8c2.9,4.3,8.4,6.6,11.3,6.6c0.8,0,1.4-0.2,1.7-0.5c1.3-1.7,1.8-6-0.7-13.5  c-0.9-2.7-0.9-3.7-0.6-3.7c0.6,0,2.5,3.1,3.4,5.6c2.2,6.2,1.1,12,1.2,14.3c0.1,1.3,0.6,1.8,1.3,1.8c0.4,0,1-0.2,1.4-0.6  c2.8-4.6,4.5-12.7,3.5-19.8c-0.6-4.1-0.8-6.7-0.3-6.7c0.1,0,0.3,0.1,0.5,0.5c6.6,9.9,1,29.6-6.8,34.6C79,51.6,72.4,55.1,61,64.1  c-0.8,0.6,0,2.7-2.6,3.6c-0.1,0.1-0.3,0.1-0.4,0.1c-2.5,0-5.5-6.9-3.7-8c0.5-0.3,0.9-0.4,1.3-0.4c0.6,0,1.1,0.2,1.8,0.2  c0.5,0,1.1-0.1,1.8-0.5C59.2,59.1,60.9,57.9,63.3,54.6z"
      />
      <path
        fill={props.fill}
        d="M36.8,54.5c-2.5-4.1-1.5-8.3-1.5-10c-0.1-1.7-0.2,0.3-1-3.8c-0.4-1.9-0.8-2.6-1.1-2.6c-0.4,0-0.7,1-0.7,2.4  c0,2.6-0.1,8.9-2.9,9.8c-0.1,0-0.1,0-0.2,0c-3.8,0-8.4-2.6-12-5.4c-4.3-5.3,3.9-6.8,8.5-9c2.7-1.2,4.9-3.3,6.2-5.9  c2.3-4.7,2.8-6.3,2.3-6.3c-0.6,0-2.7,2.7-4.2,4.8c-2.9,4.3-8.4,6.6-11.3,6.6c-0.8,0-1.4-0.2-1.7-0.6c-1.3-1.7-1.8-6,0.7-13.5  c0.9-2.7,0.9-3.7,0.6-3.7c-0.6,0-2.5,3.1-3.4,5.6c-2.2,6.2-1.1,12-1.2,14.2c-0.1,1.3-0.6,1.8-1.3,1.8c-0.4,0-1-0.2-1.4-0.6  c-2.7-4.5-4.5-12.7-3.5-19.8c0.6-4.1,0.8-6.7,0.3-6.7c-0.1,0-0.3,0.1-0.5,0.5c-6.6,9.9-1,29.6,6.8,34.6C21,51.6,27.6,55.1,39,64.1  c0.8,0.6,0,2.7,2.6,3.6c0.1,0.1,0.3,0.1,0.4,0.1c2.5,0,5.5-6.9,3.7-8c-0.5-0.3-0.9-0.4-1.3-0.4c-0.6,0-1.1,0.2-1.8,0.2  c-0.5,0-1.1-0.1-1.8-0.5C40.8,59.1,39.1,58.1,36.8,54.5z"
      />
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/component/atoms/Icon/Stag.js